var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9997 0.333374C7.79967 0.333374 0.333008 7.80004 0.333008 17C0.333008 26.2 7.79967 33.6667 16.9997 33.6667C26.1997 33.6667 33.6663 26.2 33.6663 17C33.6663 7.80004 26.1997 0.333374 16.9997 0.333374ZM16.9997 5.33337C19.7663 5.33337 21.9997 7.56671 21.9997 10.3334C21.9997 13.1 19.7663 15.3334 16.9997 15.3334C14.233 15.3334 11.9997 13.1 11.9997 10.3334C11.9997 7.56671 14.233 5.33337 16.9997 5.33337ZM16.9997 29C12.833 29 9.14967 26.8667 6.99967 23.6334C7.04967 20.3167 13.6663 18.5 16.9997 18.5C20.3163 18.5 26.9497 20.3167 26.9997 23.6334C24.8497 26.8667 21.1663 29 16.9997 29Z",
    fill: "#CED6E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGrey);
export default __webpack_public_path__ + "static/media/userGrey.27de5e0516fa8e0cd053ee72277abda6.svg";
export { ForwardRef as ReactComponent };